module.exports = __webpack_public_path__ + "media/images/story/top/step3_image-aab809ad15a0b9111922daaebaa69826.png";